import _ from 'underscore';
import { getColumnConversions, buildSortingConversions } from '@bingads-webui-campaign/column-conversions';

const ColumnConversionEnabledFeatures = {
  summary_tab_campaign: true,
  summary_tab_ad_group: true,
  summary_tab_ad: true,
  summary_tab_keyword: true,
  summary_tab_demographics: true,
  settings_locations: true,
  settings_ad_schedule: true,
  settings_devices: true,
  DsaTarget: true,
  DsaSearchTerm: true,
  AutomatedExtension: true,
  AdExtensionAssociation: true,
  DimensionsGrid: true,
  feed_items: true,
  audience_associations_level: true,
  ConversionGoalsGrid: true,
  SharedBudgetSummaryGrid: true,
  SharedBudgetEditGrid: true,
  summary_tab_search_term: true,
  target_devices_grid: true,
  PerformanceGrid: true,
  newProductGroupsGrid: true,
  PortfolioBidStrategyGrid: true,
};

export function validateOrder(preferenceConfig, columns, featureName, permissions) {
  const { dynamic = {} } = permissions || {};
  const {
    ColumnConversion: IsColumnConversionEnabled,
  } = dynamic;
  const preference = preferenceConfig;
  const sourceOrderbyInfo = preference &&
    ((preference.dataSource && preference.dataSource.orderby) || preference.orderbyInfo);
  if (IsColumnConversionEnabled && ColumnConversionEnabledFeatures[featureName]) {
    let patchedOrderbyInfo = sourceOrderbyInfo;
    if (preference.sortableHeader) {
      const columnConversions = getColumnConversions(columns);
      const { applySortingInfoConversion } = buildSortingConversions(columnConversions);
      const { sortableHeader, orderbyInfo } = applySortingInfoConversion({
        sortableHeader: preference.sortableHeader,
        orderbyInfo: sourceOrderbyInfo,
      });
      preference.sortableHeader = sortableHeader;
      patchedOrderbyInfo = orderbyInfo;
    }

    if (patchedOrderbyInfo) {
      const sortableColumns = _.chain(columns)
        .filter(column => column.sortable)
        .map(column => column.sortable.key)
        .value();

      const updatedOrder = [];
      _.each(patchedOrderbyInfo, (order) => {
        if (_.contains(sortableColumns, order.key)) {
          updatedOrder.push(order);
        }
      });

      if (preference && preference.dataSource && preference.dataSource.orderby) {
        preference.dataSource.orderby = updatedOrder;
      } else if (preference.orderbyInfo) {
        preference.orderbyInfo = updatedOrder;
      }
    }
  } else if (sourceOrderbyInfo) {
    const sortableColumns = _.chain(columns)
      .filter(column => column.sortable)
      .map(column => column.sortable.key)
      .value();

    const updatedOrder = [];
    _.each(sourceOrderbyInfo, (order) => {
      if (_.contains(sortableColumns, order.key)) {
        updatedOrder.push(order);
      }
    });

    if (preference.dataSource && preference.dataSource.orderby) {
      preference.dataSource.orderby = updatedOrder;
      if (_.isEmpty(preference.dataSource.orderby)) {
        delete preference.sortableHeader;
      }
    } else if (preference.orderbyInfo) {
      preference.orderbyInfo = updatedOrder;
    }
  }
}
